<template>
    <component class="ur-data-grid__content__cell__value" :is="cellCompo"
            ref="editCompo"
            :row="rowInfo.row" :ori-value="value" :text="text"
            :style="valueStyle" :field="field"
            v-on="$listeners"
            @mousedown="()=>{}"
            @input="onInput"
            @focus="resetRule" @blur="onInput"
            @on-flotage="toggleFlotage"/>
    <!-- @mousedown.native.stop="()=>{}" -> @mousedown="()=>{}" 로 수정 -->
</template>


<script>
const COMPO_MIXIN = {
    data(){return {
        value : null
    }},
    props:['row','ori-value','text', "field"],
    watch : {
        oriValue: {immediate:true, handler(v,w) {
            this.value = v;
        }},
        value(v, w) {
            this.$emit('input',v);
        }
    },
    computed: {
        $caller() {return this.$parent.gridInfo.caller}
    },
    methods: {
        // [METHOD] Will be overrided by user created function!!
        focus() {
            var $el = (()=>{
                if(this.$children && this.$children.length) {
                    return this.$children[0];
                }
                if(this.$el) {
                    return this.$el;
                }
                return null;
            })();
            if(!$el) return;
            if(!$el.focus) return;
            if(typeof $el.focus !== 'function') return;
            // 
            $el.focus();
        }
    }
}

export default {
    name : "urDataGridContentCellEditCompo",
    inject : ['gridInfo', 'rowInfo'],
    props : {
        field : {type:Object},
        text  : null, /* type any */
        value : null, /* type any */
    },
    computed:{
        // [COMPUTED] Custom component
        cellCompo(){
            const field = this.field, 
                  compo = field.editComponent;
            if(typeof compo === 'string') {
                return {
                    mixins : [COMPO_MIXIN],
                    template : compo
                }
            } else {
                var __compo = compo;
                __compo.mixins = [COMPO_MIXIN];
                return __compo;
            }
        },
        // [COMPUTED] Style, Cell value style
        valueStyle() {
            var field = this.field;
            let style = {};
            if(field.align) {style['text-align'] = field.align}
            return style;
        }
    },
    methods: {
        onInput(_v) {
            const opts = this.gridInfo.opts,
                  row = this.rowInfo.row,
                  fil = this.field;
            var v = _v;
            if(opts.cellEdit) {
                this.gridInfo.func.cellTempValue(v);
            } else if(opts.rowEdit && row.__editMode) {
                this.gridInfo.vars_currEditRow[fil.value] = v;
            }
            this.$emit('input',v);
        },
        applyRule(){
            if(this.gridInfo.opts.manualValid) return;
            var $l=this.$listeners;
            if($l.applyRule) {$l.applyRule()}
        },
        resetRule(){
            var $l=this.$listeners;
            if($l.resetRule) {$l.resetRule()}
        },
        focus() {
            if(!this.$refs.editCompo)return;
            if(!this.$refs.editCompo.focus)return;
            if(typeof this.$refs.editCompo.focus !== 'function')return;
            this.$refs.editCompo.focus();
        },
        toggleFlotage(v) {this.gridInfo.func.setCellFlotage(v)},
    }
}
</script>